import { type ReactNode } from 'react';
import { View, StyleSheet, StyleProp, ViewStyle } from 'react-native';
import { ColumnWidth, ColumnAlignment } from './types';
import { theme } from '@socrait/react';
interface TableCellProps {
  borderBottomColor?: string;
  width: ColumnWidth;
  align?: ColumnAlignment;
  children?: ReactNode;
  noBorder?: boolean;
  style?: StyleProp<ViewStyle>;
}

export function TableCell({
  borderBottomColor = theme.colors.gray,
  width,
  align = 'left',
  children,
  noBorder = false,
  style,
}: TableCellProps) {
  const widthStyle =
    width.type === 'flex'
      ? { flex: width.flex }
      : width.type === 'fixed'
        ? { width: width.width }
        : { flexShrink: 1, flexGrow: 0 };

  return (
    <View
      style={[
        styles.cell,
        widthStyle,
        align === 'center' && styles.cellAlignCenter,
        align === 'right' && styles.cellAlignRight,
        { borderBottomColor },
        noBorder && styles.cellNoBorder,
        style,
      ]}>
      {children}
    </View>
  );
}

const styles = StyleSheet.create({
  cell: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingBottom: theme.spacing.medium,
    borderBottomWidth: 1,
  },
  cellNoBorder: {
    borderBottomWidth: 0,
  },
  cellAlignCenter: {
    alignItems: 'center',
  },
  cellAlignRight: {
    alignItems: 'flex-end',
  },
});
